import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import Section from "components/Section";
import { useState } from "react";
import AddCommentDialog from "./AddCommentDialog";
import { useChecklistContext } from "context/ChecklistContext";
import EmptyMessage from "components/EmptyMessage";
import ChecklistComment from "./ChecklistComment";

const ChecklistComments: React.FC = () => {
  const { checklist, comments } = useChecklistContext();
  const [showAddCommentDialog, setShowAddCommentDialog] = useState(false);

  // Sort comments by timestamp in ascending order
  // const comments = useMemo(() => {
  //   return [...contextComments].sort((a, b) => {
  //     return new Date(a.postedAt).getTime() - new Date(b.postedAt).getTime();
  //   });
  // }, [contextComments]);

  return (
    <Section p={1}>
      {comments.length > 0 ? (
        <Box sx={{ display: "grid", gap: 1 }}>
          {comments.map((comment) => (
            <ChecklistComment comment={comment} />
          ))}
        </Box>
      ) : (
        <EmptyMessage m={1}>Inga kommentarer</EmptyMessage>
      )}

      <Box display="flex" justifyContent="end" mt={1}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setShowAddCommentDialog(true)}
        >
          Ny kommentar
        </Button>
      </Box>

      {showAddCommentDialog && (
        <AddCommentDialog
          checklistId={checklist.id}
          onClose={() => setShowAddCommentDialog(false)}
        />
      )}
    </Section>
  );
};

export default ChecklistComments;
